import React from "react";
import Emp_List from "./EmpList";
import CharchaShorts from "../../AllEpisode/AllEpisode_Components/CharchaShorts";
import data from "../../common/ShareText.json";

const ExploreAllEpisodes = ({
  episodeData,
  shortsData,
  handleclick,
  handleShareData,
}) => {
  return (
    <>
      <section className="eae_sec">
        <div className="container-fluid">
          <div className="eae_con_pad">
            <div className="eae_content">
              <img className="ay1_1" src="/assets/vimages/ay1.png" alt="" />
              <img className="ay2_1" src="/assets/vimages/ay2.png" alt="" />
              <h2>
                Explore All Episodes:
                <br />
                Unlock Wisdom & Inspiration
              </h2>
              {/* <p>
                The interaction every student in India is waiting for is here -
                Pariksha Pe Charcha with Hon’ble Prime Minister Narendra Modi!
                Prime Minister Narendra Modi{" "}
              </p> */}

              {episodeData && (
                <Emp_List
                  episodeData={episodeData}
                  handleShareData={handleShareData}
                />
              )}
            </div>
          </div>
        </div>
        {/* <div className="empowering_shorts">
          {shortsData && (
            <CharchaShorts
              shortsData={shortsData}
              handleclick={handleclick}
              type={"shorts"}
              isShort={true}
              sharetext={data.main}
              handleShareData={handleShareData}
            />
          )}
        </div> */}
      </section>
    </>
  );
};

export default ExploreAllEpisodes;
